import React, { useState, useEffect, useContext } from "react";
import CompanyInfoModal from "~/pages/applyFormMange/modals/CompanyInfoModal";
import useAlert from "~/common/hooks/useAlert";

import QnaForm from "./inputComponent/faq/QnaForm";
import useRequest from "~/common/hooks/useRequest";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const ApplyFormMange = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	// const tabMenuList = [
	// 	{ id: "TAB 1", title: "Apply 양식" },
	// 	{ id: "TAB 2", title: "FAQ" },
	// ];
	const { formDetail, applyMangeForm, list, qList, isUse, mainImg, reviewSettingIdx } = useContext(ApplyContext);

	// const [currentTab, setCurrentTab] = useState("TAB 1");
	const [warningMsg, setWarningMsg] = useState("");
	const [companyInfoModal, setCompanyInfoModal] = useState();
	const [showEditSuccess, EditSuccess] = useAlert();
	const applyRegRequest = useRequest("post", "/vc/apply/template");
	const [showWarningAlert, Warning] = useAlert();

	useEffect(() => {
		formDetail();
	}, []);

	const submit = (data) => {
		const formData = {
			image: {
				name: "",
				size: 0,
				path: mainImg,
			},
			reviewSettingIdx: reviewSettingIdx,
			title: data.inquiry,
			description: data.inquiryDesc,
			inputs: list,
			qna: qList,
			isUse: isUse,
			containInfoContents: true
		};
		applyRegRequest.call(formData);
	};

	useEffect(() => {
		switch (applyRegRequest.state) {
			case API_STATE.done:
				showEditSuccess().then(() => navigate("/applyForm/view"));
				break;
			case API_STATE.error:
				setWarningMsg(t("pages.applyFormMange.ApplyForm.setWarningMsg"));
				showWarningAlert();
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applyRegRequest.state, applyRegRequest.response, applyRegRequest.error]);
	return (
		<>
			<div className="p__apply-FormMange light">
				{/* 탭 메뉴 */}
				{/* <div className="apply-tab-menu">
					<TabMenu
						tabItem={tabMenuList}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
				</div> */}
				<QnaForm />
				{/* <If condition={currentTab} {...{ setCurrentTab }}>
					<Case condition="TAB 1">
						<InqueryForm />

					</Case>
					<Case condition="TAB 2">
						<QnaForm />
					</Case>

				</If> */}

				<div className="btn__group">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => navigate("/applyForm/view")}
					>
						{t("pages.applyFormMange.ApplyForm.btn-cancel")}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={applyMangeForm.handleSubmit(submit)}
					>
						{t("pages.applyFormMange.ApplyForm.btn-save")}
					</button>
				</div>
			</div>
			<EditSuccess
				type="success"
				message={t("pages.applyFormMange.ApplyForm.successMassage")}
				confirm={t("common.commonWord.button.check")}
			/>
			{/*기본 기업 정보 모달*/}
			<CompanyInfoModal {...{ companyInfoModal, setCompanyInfoModal }} />
			<Warning
				type="info"
				message={t("pages.applyFormMange.ApplyForm.WarningMassage")}
				subMessage={warningMsg}
				confirm={t("common.commonWord.button.check")}
			/>
		</>
	);
};

export default ApplyFormMange;
